import React from "react";
import RouteLink from "./RouteLink";
import { Link } from "react-router-dom";
import homeIconSrc from "assets/img/icons/icon_home_v01.png";
import childIconSrc from "assets/img/icons/icon_child_v01.png";
import newsIconSrc from "assets/img/icons/icon_news_v01.png";
import donationIconSrc from "assets/img/icons/icon_donation_v01.png";
import emailIconSrc from "assets/img/icons/icon_email_v01.png";
// import visitIconSrc from "assets/img/icons/icon_visit_v01.png";
import faqIconSrc from "assets/img/icons/icon_faq_v01.png";
import talkIconSrc from "assets/img/icons/icon_talk_v01.png";
import Icon from "../../shared/Icon";


import crossIcon from "assets/img/main-menu/v2/icon_cross.png";
import homeIcon from "assets/img/main-menu/v2/icon_home.png";
import childIcon from "assets/img/main-menu/v2/icon_child.png";
import reportIcon from "assets/img/main-menu/v2/icon_report.png";
import donationIcon from "assets/img/main-menu/v2/icon_donation.png";
import letterIcon from "assets/img/main-menu/v2/icon_letter.png";
import messageIcon from "assets/img/main-menu/v2/icon_message.png";
import faqIcon from "assets/img/main-menu/v2/icon_faq.png";
import pesoIcon from "assets/img/main-menu/v2/icon_peso.png";


//icon_cross.png
const HeaderNav = props => {
    function displayMenu(value) {
        const childrenList = props.childrenList;

        if (!value) {
            return;
        }

        if (
            typeof childrenList === "undefined" ||
            !Array.isArray(childrenList)
        ) {
            return;
        }
        return childrenList.map((item, index) => {
            return (
                <li key={index}>
                    <Link to={`/dashboard/${value}/${item.child_id}`}>
                        {item.name}
                    </Link>
                </li>
            );
        });
    }

    function displayChildMenu() {
        return displayMenu("child");
    }

    return (
        <nav id="donor-menu" className="container">
            <div id="menu-wrap" className="collapse navbar-collapse">
                <ul id="main-menu">
                    <li className="home-link">
                        <RouteLink icon={homeIcon} path="/dashboard">
                            Home
                        </RouteLink>
                    </li>

                    <li
                        role="presentation"
                        className="child-link dropdown child-dropdown"
                    >
                        <a
                            className="dropdown-toggle"
                            data-toggle="dropdown"
                            href="#children-dropdown"
                            role="button"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <Icon bgUrl={childIcon} />
                            <span className="menu-text">
                                Child <span className="caret" />
                            </span>
                        </a>
                        <ul className="dropdown-menu scroll">{displayChildMenu()}</ul>
                    </li>

                    <li className="updates-link">
                        <RouteLink
                            icon={reportIcon}
                            path="/dashboard/my-updates"
                        >
                            My Updates
                        </RouteLink>
                    </li>

                    <li className="donation-link">
                        <RouteLink
                            icon={pesoIcon}
                            path="/dashboard/my-donation"
                        >
                            My Donation
                        </RouteLink>
                    </li>

                    <li
                        role="presentation"
                        className="email-link dropdown child-dropdown"
                    >
                        <RouteLink
                            icon={letterIcon}
                            path="/dashboard/letters"
                        >
                            Letters
                        </RouteLink>
                    </li>

                    <li className="faq-link">
                        <RouteLink icon={faqIcon} path="/dashboard/faq">
                            FAQs
                        </RouteLink>
                    </li>

                    <li className="devotion-link">
                        <RouteLink icon={crossIcon} path="/dashboard/weekly-devotion">
                            Verse of the Week
                        </RouteLink>
                    </li>

                    <li className="contact-link">
                        <RouteLink
                            icon={messageIcon}
                            path="/dashboard/contact-us"
                        >
                            Contact Us
                        </RouteLink>
                    </li>

                    {/* <li className="visit-link">
                    <RouteLink
                            icon={visitIconSrc}
                            path="/dashboard/visit-my-child"
                        >
                            Visit my Child
                        </RouteLink>
                    </li> */}
                </ul>
            </div>
        </nav>
    );
};

export default HeaderNav;
